export enum RoomNames {
    DEFAULT_ROOM = 'default-room',
    PRODUCTION_ORDERS_ROOM = 'production-orders-room',
    CONFIGURATIONS_ROOM = 'configurations-room',
    ARTICLE_BATCHES_ROOM = 'article-batches-room',
    ARTICLE_FAMILIES_ROOM = 'article-families-room',
    ARTICLE_FEATURES_ROOM = 'article-features-room',
    ARTICLE_TYPES_ROOM = 'article-types-room',
    ARTICLES_ROOM = 'articles-room',
    ASSESS_ROOM = 'assess-room',
    CUSTOM_FIELDS_ROOM = 'custom-fields-room',
    CUSTOMERS_ROOM = 'customers-room',
    FINAL_PRODUCTS_ROOM = 'final-products-room',
    IDENTITY_DOCUMENT_TYPES_ROOM = 'identity-document-types-room',
    LOSS_REASONS_ROOM = 'loss-reasons-room',
    MACHINE_MEASUREMENTS_ROOM = 'machine-measurements-room',
    MACHINE_MEASUREMENTS_VALUES_ROOM = 'machine-measurements-values-room',
    MACHINES_ROOM = 'machines-room',
    MACHINES_DASHBOARD_ROOM = 'machines-dashboard-room',
    MEASUREMENT_UNITS_ROOM = 'measurement-units-room',
    PACKAGINGS_ROOM = 'packagings-room',
    PACKAGING_TYPES_ROOM = 'packaging-types-room',
    PAUSES_ROOM = 'pauses-room',
    PAUSE_REASONS_ROOM = 'pause-reasons-room',
    PERMISSIONS_ROOM = 'permissions-room',
    PAUSE_REASONS_ROOM_BY_MACHINE = 'pause-reasons-room|machine-id',
    PRODUCTION_ORDER_PROCESSES_ROOM = 'production-order-processes-room',
    PRODUCTION_PROCESSES_ROOM = 'production-processes-room',
    PRODUCTION_ROUTES_ROOM = 'production-routes-room',
    SCRAP_CAUSES_ROOM = 'scrap-causes-room',
    SCRAP_REASONS_ROOM = 'scrap-reasons-room',
    SCREENS_ROOM = 'screens-room',
    SENSORS_ROOM = 'sensors-room',
    STATUSES_ROOM = 'statuses-room',
    USERS_ROOM = 'users-room',
}

export enum Client {
    DEFAULT_CLIENT = 'default-client',
}

export function formatClientRoom(client: Client, room: RoomNames): string {
    return `${client}|${room}`;
}

export function formatClientRoomId(client: Client, room: RoomNames, id:number): string {
    return `${client}|${room}|${id}`;
}

export function formatClientRoomProcessId(client: Client, room: RoomNames, processId:number): string {
    return `${client}|${room}|process|${processId}`;
}